import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { DateTime } from 'luxon';

interface InputProps extends FormlyFieldProps {}
export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'input-read' | Type<InputReadType>;
}
@Component({
  selector: 'input-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `
    <div class= "">
        <p>{{field.formControl.value}}</p>
    </div>
  `,
})
export class InputReadType extends FieldType<FieldTypeConfig<InputProps>>{

    getValue(){
        const value = this.field.formControl.value;
        return value
    }

}
